import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WriteAcceptingForm} from "@/pages/Accepting/WriteAccepting";
import {AcceptingPO, PlanPO, ReviewPO, TaskPO} from "@/model/mission";

export enum AcceptingEnum {
    GetAcceptingPage = "/accepting/getAcceptingPage",
    GetAccepting = "/accepting/getAccepting",
    CreateAccepting = "/accepting/createAccepting",
}

export interface AcceptingPageBO {
    keyword?: string;
}

export interface AcceptingPageVO extends AcceptingPO {
    planName: string;
    executor: string;
    virtue: string;
    virtueId: number;
    priority: string;
    priorityId: number;
    taskName: string;
    reviewerId: number;
    status: number;
    executorId: number
}

export interface AcceptingVO extends AcceptingPO {
    task: TaskPO
    plan: PlanPO
    review: ReviewPO
}

export const useQueryAcceptingPage = () => useMutation<BaseVO<PaginationVO<AcceptingPageVO>>, null, AcceptingPageBO>({
    mutationFn: (data: AcceptingPageBO) => http.post<BaseVO<PaginationVO<AcceptingPageVO>>>({
        url: AcceptingEnum.GetAcceptingPage,
        data: data,
    }),
})

export const useQueryAccepting = (params: GetByIdBO, enabled: boolean) => useQuery<BaseVO<AcceptingVO>>({
    queryKey: [params.id], enabled, queryFn: () => http.get<BaseVO<AcceptingVO>>({
        url: AcceptingEnum.GetAccepting,
        params: params
    })
})

export const useCreateAccepting = () => useMutation({
    mutationFn: (data: WriteAcceptingForm) => http.put<BaseVO<null>>({url: AcceptingEnum.CreateAccepting, data}),
})




